import { useState, useEffect, useRef } from "react";

// Values are what gets stored in MongoDB (see schema: referralSources);
// labels are what the visitor sees.
export const REFERRAL_OPTIONS = [
  { value: "Word of Mouth", label: "Word of Mouth (e.g. colleague, friend)" },
  { value: "Social Media", label: "Social Media" },
  { value: "News", label: "News" },
  { value: "Community Event", label: "Community Event" },
  {
    value: "Organization",
    label: "Organization (e.g. FireSafe, CAL FIRE, ARISE-US)",
  },
  { value: "Other", label: "Other" },
];

const ReferralMultiSelect = ({
  selected = [],
  otherText = "",
  onChange,
  onOtherChange,
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  // Close the list when the visitor clicks anywhere outside of it
  useEffect(() => {
    if (!open) return undefined;
    const handleOutsideClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [open]);

  const toggleOption = (value) => {
    const next = selected.includes(value)
      ? selected.filter((item) => item !== value)
      : [...selected, value];
    onChange(next);
  };

  const handleControlKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setOpen((prev) => !prev);
    } else if (e.key === "Escape") {
      setOpen(false);
    }
  };

  const summary =
    selected.length === 0 ? "-Select all that apply-" : `${selected.length} selected`;

  return (
    <>
      <div className="form-group multi-select" ref={wrapperRef}>
        <label id="referralSources-label">
          How did you hear about the Scorecard?
        </label>
        <div
          className={`multi-select-control${open ? " open" : ""}`}
          role="button"
          tabIndex={0}
          aria-haspopup="true"
          aria-expanded={open}
          aria-labelledby="referralSources-label"
          onClick={() => setOpen((prev) => !prev)}
          onKeyDown={handleControlKeyDown}
        >
          <span className={selected.length === 0 ? "placeholder" : ""}>
            {summary}
          </span>
          <i
            className={`fa-solid ${open ? "fa-caret-up" : "fa-caret-down"}`}
            aria-hidden="true"
          ></i>
        </div>
        {open && (
          <div
            className="multi-select-options"
            role="group"
            aria-labelledby="referralSources-label"
          >
            {REFERRAL_OPTIONS.map((option) => (
              <label key={option.value} className="multi-select-option">
                <input
                  type="checkbox"
                  checked={selected.includes(option.value)}
                  onChange={() => toggleOption(option.value)}
                />
                <span>{option.label}</span>
              </label>
            ))}
          </div>
        )}
      </div>
      {selected.includes("Other") && (
        <div className="form-group">
          <label htmlFor="referralOther">*Please mention where</label>
          <input
            type="text"
            id="referralOther"
            name="referralOther"
            value={otherText}
            onChange={(e) => onOtherChange(e.target.value)}
            maxLength={200}
            required
          />
        </div>
      )}
    </>
  );
};

export default ReferralMultiSelect;
